import React, { useMemo,  useContext, useState, useEffect } from 'react';
import siblingPlaceholder from './assets/sibling-placeholder.png';
import calendarPlaceholder from './assets/calendar-placeholder.png';
import cardPlaceholder from './assets/card-placeholder.png';
import ornamentPlaceholder from './assets/ornament-placeholder.png';
import magnetPlaceholder from './assets/magnet-placeholder.png';
import styles from './HolidayBuilder.module.scss';
import DisplayableSheet from '../../../PackageBuilders/MultiPose/DisplayableSheet';
import { addonSheetToSheet } from '../../../PackageBuilders/MultiPose/functions';
import Image from "../../../Image";
import defaultBackground from "../../../../assets/Package_Blue.png";
import greenImage from './assets/PromoImage_Slide_1_Green.jpg'; 
import redImage from './assets/PromoImage_Slide_1_Red.jpg'; 
import blueImage from './assets/PromoImage_Slide_1_Blue.jpg'; 
import blackImage from './assets/PromoImage_Slide_1_Black.jpg'; 
import purpleImage from './assets/PromoImage_Slide_1_Purple.jpg';

import davisImage from './assets/DAV_logo_Announcement.jpg';
import beyerImage from './assets/BEY_logo_Announcement.jpg';
import hollisterImage from './assets/HOLLISTER_logo_Announcement.jpg';
import enochsImage from './assets/ENO_logo_Announcement.jpg';
import escalonImage from './assets/ESC_logo_Announcement.jpg';

import gregoriImage from './assets/GRE_logo_Announcement.jpg';
import mcollegeImage from './assets/MIDDLE_COLLEGE_logo_Announcement.jpg';
import collegiateImage from './assets/COLLEGIATE_logo_Announcement.jpg';
import centralvalleyImage from './assets/CENTRAL_VALLEY_logo_Announcement.jpg';
import lincolnImage from './assets/LINCOLN_logo_Announcement.jpg';

import calaverasImage from './assets/CALAVERAS_logo_Announcement.jpg';
import tokayImage from './assets/Tokay_Logo_Announcement.jpg';

import cursiveForeground from './assets/cursiveForeground.png';
import plaidBackground from './assets/Senior_Grey.jpg';
import { CustomerContext } from '../../../../contexts/CustomerContext';
import axios from 'axios';
import '../../../../fonts/fonts.scss';

export default function Item({ siblingProps, addon, variant, titleText, subtitleText, onClick = () => {}, pose, background }) {
  const { customer } = useContext(CustomerContext);
  const [studentData, setStudentData] = useState(null);
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);

  const [componentWidth, setComponentWidth] = useState(0);

useEffect(() => {
  const updateWidth = () => {
    const element = document.getElementById('item-wrapper');
    if (element) {
      const width = element.getBoundingClientRect().width;
      setComponentWidth(width);
    } else {
    }
  };

  setTimeout(updateWidth, 100);

  const resizeObserver = new ResizeObserver(entries => {
    for (let entry of entries) {
      setComponentWidth(entry.contentRect.width);
    }
  });

  const element = document.getElementById('item-wrapper');
  if (element) {
    resizeObserver.observe(element);
  }

  window.addEventListener('resize', updateWidth);

  return () => {
    window.removeEventListener('resize', updateWidth);
    resizeObserver.disconnect();
  };
}, []);

  const renderImageComponent = () => {
    switch (variant) {
      case 'ornament':
        return (
          <div className={styles.itemImgWrapper}>
            <Image src={addon.imageUrl} alt="" classes={styles.packageImage} />
            <div className={styles.ornament}>
              <Image src={pose?.watermarkUrl} alt=""/>
            </div>
          </div>
        )
      case 'gradannouncementregular':
        return (
          <div className={styles.itemImgWrapper}>
            <Image src={addon.imageUrl} alt="" classes={styles.packageImage} />
            <div className={styles.gradannouncementregular}>
              <Image src={pose?.watermarkUrl} alt=""/>
            </div>
          </div>
        )
        case 'gradbrown':
        return (
          <div className={styles.itemImgWrapper}>
            <Image src={addon.imageUrl} alt="" classes={styles.packageImage} />
            <div className={styles.gradbrown}>
              <Image src={pose?.watermarkUrl} alt=""/>
            </div>
          </div>
        )
      case 'gradplaid':
        return (
          <div className={styles.itemImgWrapper}>
            <Image src={addon.imageUrl} alt="" classes={styles.packageImage} />
            <div className={styles.gradplaid}>
              
              <Image src={plaidBackground} alt=""/>
              <Image src={pose?.watermarkUrl} alt="" classes={styles.gradplaidForeground}/>
            </div>
          </div>
        )
        case 'gradcursive':
        return (
          <div className={styles.itemImgWrapper}>
            <Image src={addon.imageUrl} alt="" classes={styles.packageImage} />
            <div className={styles.gradcursive}>
              <Image src={cursiveForeground} alt=""  classes={styles.gradcursiveForeground}/>
              <Image src={pose?.watermarkUrl} alt=""/>
               
              
            </div>
          </div>
        )
        case 'gradclassicvert':
        return (
          <div className={styles.itemImgWrapper}>
            <Image src={addon.imageUrl} alt="" classes={styles.packageImage} />
            <div className={styles.gradclassicvert}>
              <Image src={pose?.watermarkUrl} alt=""/>
            </div>
          </div>
        )
      case 'gradannouncement':
        const getImageSource = () => {
          if (!pose?.watermarkUrl) {
            console.log("No image URL found");
            return blackImage;
          }
          if (pose?.watermarkUrl.toLowerCase().includes('19-s')) {
            return enochsImage;
          }
          if (pose?.watermarkUrl.toLowerCase().includes('19-s')) {
            
            return enochsImage;
          }
          
          
          if (pose?.watermarkUrl.toLowerCase().includes('546-s')) {
            
            return davisImage;
          }
          if (pose?.watermarkUrl.toLowerCase().includes('69-s')) {
            
            return beyerImage;
          }
          if (pose?.watermarkUrl.toLowerCase().includes('93-s')) {
            
            return hollisterImage;
          }
          if (pose?.watermarkUrl.toLowerCase().includes('106-s')) {
            
            return escalonImage;
          }
          if (pose?.watermarkUrl.toLowerCase().includes('92-s')) {
            
            return gregoriImage;
          }

          if (pose?.watermarkUrl.toLowerCase().includes('676-s')) {
            
            return mcollegeImage;
          }
          if (pose?.watermarkUrl.toLowerCase().includes('389-s')) {
            
            return centralvalleyImage;
          }
          if (pose?.watermarkUrl.toLowerCase().includes('195-s')) {
            
            return lincolnImage;
          }
          if (pose?.watermarkUrl.toLowerCase().includes('105-s')) {
            
            return calaverasImage;
          }
          if (pose?.watermarkUrl.toLowerCase().includes('758-s')) {
            
            return tokayImage;
          }
          
          if (pose?.watermarkUrl.toLowerCase().includes('471-s')) {
            
            return collegiateImage;
          }
          if (pose?.watermarkUrl.toLowerCase().includes('106-s')) {
            return purpleImage;
          }
          return blackImage;
        };
        return (
          <div className={styles.itemImgWrapper}>
            <Image src={getImageSource()} alt="" classes={styles.packageImage} />
            
            <div className={styles.gradannouncement}>
              <Image src={pose?.watermarkUrl} alt=""/>
            </div>
          </div>
        )
      case 'card':
        return cardPlaceholder;
      case 'keychain':
        return (
          <div className={styles.itemImgWrapper}>
            <Image src={addon.imageUrl} alt="" classes={styles.packageImage} />
            <div className={styles.poseOneKeychain}>
              <Image src={pose?.watermarkUrl} alt=""/>
            </div>
          </div>
        )
      case 'magnet':
        return (
          <div className={styles.itemImgWrapper}>
            <Image src={addon.imageUrl} alt="" classes={styles.packageImage} />
            <div className={styles.poseOneMagnet}>
              <Image src={pose?.watermarkUrl} alt=""/>
            </div>
            <div className={styles.poseTwoMagnet}>
              <Image src={pose?.watermarkUrl} alt=""/>
            </div>
          </div>
        );
        case 'calendar':
          return (
            <div className={styles.itemImgWrapper}>
              <Image src={addon.imageUrl} alt="" classes={styles.packageImage} />
              
              <div className={styles.calendar}>
                <Image src={pose?.watermarkUrl} alt=""/>
              </div>
            </div>
          );

          case 'eightbytenG':
            return (
              <div className={styles.itemImgWrapper}>
                <Image src={addon.imageUrl} alt="" classes={styles.packageImage} />
                
                <div className={styles.eightbytenG}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>
              </div>
            );
            case 'coffeecup':
            return (
              <div className={styles.itemImgWrapper}>
                <Image src={addon.imageUrl} alt="" classes={styles.packageImage} />
                
                <div className={styles.coffeecup}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>
              </div>
            );
          case 'fivebyseven':
            return (
              <div className={styles.itemImgWrapper}>
                <Image src={addon.imageUrl} alt="" classes={styles.packageImage} />
                
                <div className={styles.poseOnefivebyseven}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>
                <div className={styles.poseTwofivebyseven}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>
              </div>
            );
          case 'threebyfive':
            return (
              <div className={styles.itemImgWrapper}>
                <Image src={addon.imageUrl} alt="" classes={styles.packageImage} />
                
                <div className={styles.poseOnethreebyfive}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>
                <div className={styles.poseTwothreebyfive}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>
                <div className={styles.poseThreethreebyfive}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>
                <div className={styles.poseFourthreebyfive}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>
              </div>
            );
          case 'wallets':
            return (
              <div className={styles.itemImgWrapper}>
                <Image src={addon.imageUrl} alt="" classes={styles.packageImage} />
                
                <div className={styles.poseOneWallet}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>
                <div className={styles.poseTwoWallet}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>
                <div className={styles.poseThreeWallet}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>
                <div className={styles.poseFourWallet}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>

                <div className={styles.poseFiveWallet}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>
                <div className={styles.poseSixWallet}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>
                <div className={styles.poseSevenWallet}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>
                <div className={styles.poseEightWallet}>
                  <Image src={pose?.watermarkUrl} alt=""/>
                </div>
              </div>
            );
      case 'plaque':
        return (
          <div className={styles.itemImgWrapper}>
            <Image src={addon.imageUrl} alt="" classes={styles.packageImage} />
            <div className={styles.poseOnePlaque}>
              <Image src={pose?.watermarkUrl} alt=""/>
            </div>
          </div>
        );
      default:
        return null;
    }
  }

  const sheets = useMemo(() => {
    if (variant !== 'sibling') return [];

    return siblingProps.addons.map((addon) => addonSheetToSheet({ addon, background: siblingProps.background, pose: siblingProps.pose }));
  }, [variant, siblingProps]);

  return (
    <button className={styles.item} type="button" onClick={onClick}>
      <div id="item-wrapper" className={styles.itemImgWrapper}>
        {variant !== 'sibling' && addon.imageUrl && renderImageComponent()}
        {/*{variant === 'sibling' && sheets.map((sheet) => <DisplayableSheet sheet={sheet} />)}*/}
      </div>
      <div className={styles.titlesWrapper}>
        <span className={styles.title}>{titleText}</span>
        <span className={styles.subtitle}>{subtitleText}</span>
      </div>
    </button>
  );
}
